// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27 xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 stroke=%27%23888888%27 stroke-width=%271.6%27 stroke-linecap=%27round%27%3E%3Cpath d=%27M3 4.5l3 3 3-3%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Legacy tokens — alias al sistema Troly · Onyx Club ──────
   Los 50+ consumidores existentes (\`var(--bg)\`, \`var(--ink)\`, etc.)
   heredan ahora el theming Troly sin tocar reglas individuales.
   El flip light/dark lo maneja tokens.css vía [data-theme="light"]. */
:root {
  --teal:        var(--troly-action);
  --teal-bright: #2fedcd;
  --teal-dark:   #0e9e82;
  --teal-glow:   rgba(69, 230, 194, 0.12);

  --bg:          var(--troly-bg);
  --surface:     var(--troly-bg-elevated);
  --ink:         var(--troly-fg);
  --ink80:       var(--troly-fg-muted);
  --muted:       var(--troly-fg-muted);
  --line:        var(--troly-border-strong);
  --line-soft:   var(--troly-border);

  /* Dark-* tokens — fijos en oscuro siempre (usados por auth
     shells que no responden al toggle de tema). */
  --dark-bg:     var(--troly-ink);
  --dark-surface:var(--troly-steel);
  --dark-line:   rgba(242, 239, 233, 0.12);

  --font: var(--troly-font-body);
  --radius: var(--troly-radius-md);
  --shadow: 0 2px 12px rgba(0,0,0,0.07);
  --shadow-md: 0 4px 24px rgba(0,0,0,0.10);
}

/* ── Reset ───────────────────────────────────────────────────── */
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
html { scroll-behavior: smooth; }
body {
  font-family: var(--font);
  background: var(--bg);
  color: var(--ink);
  -webkit-font-smoothing: antialiased;
  transition: background 0.25s, color 0.25s;
}
a { color: inherit; text-decoration: none; }
img { max-width: 100%; display: block; }
button { cursor: pointer; font-family: var(--font); }
input, select, textarea { font-family: var(--font); }

/* ── Layout ──────────────────────────────────────────────────── */
.container { max-width: 1100px; margin: 0 auto; padding: 0 40px; }

/* ── Buttons ─────────────────────────────────────────────────── */
/* Primary — migrado a tokens Troly · Onyx Club */
.btn-teal {
  background: var(--troly-action);
  color: var(--troly-action-ink);
  border: none;
  border-radius: var(--troly-radius-md);
  padding: 12px 20px;
  font-family: var(--troly-font-body);
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: -0.005em;
  transition: opacity .18s, transform .12s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
}
.btn-teal:hover  { opacity: .85; transform: translateY(-1px); }
.btn-teal:active { transform: translateY(0); }
.btn-teal:disabled { opacity: .5; cursor: not-allowed; transform: none; }

/* Ghost — migrado a tokens Troly · Onyx Club */
.btn-ghost {
  background: transparent;
  color: var(--troly-fg);
  border: 1px solid var(--troly-border);
  border-radius: var(--troly-radius-md);
  padding: 12px 20px;
  font-family: var(--troly-font-body);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.005em;
  transition: border-color .18s, background .18s, color .18s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
}
.btn-ghost:hover { border-color: var(--troly-action); background: var(--teal-glow); color: var(--troly-fg); }

/* ── Dark page shell (auth screens) ─────────────────────────── */
.dark-page {
  min-height: 100vh;
  background: var(--dark-bg);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  font-family: var(--font);
}

/* ── Animations ──────────────────────────────────────────────── */
@keyframes fadeUp {
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes pulse {
  0%,100% { box-shadow: 0 0 0 0 rgba(69,230,194,.3); }
  50%      { box-shadow: 0 0 0 8px rgba(69,230,194,0); }
}

.fade-up { animation: fadeUp .45s ease both; }
.fade-in { animation: fadeIn .35s ease both; }

/* ── Scrollbar ───────────────────────────────────────────────── */
::-webkit-scrollbar { width: 5px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: var(--line); border-radius: 3px; }

/* ── Inputs — unificados sobre tokens Troly · Onyx Club ─────── */
.dark-input,
.light-input,
.light-select {
  width: 100%;
  background: var(--troly-bg-elevated);
  color: var(--troly-fg);
  border: 1px solid var(--troly-border);
  border-radius: var(--troly-radius-md);
  font-family: var(--troly-font-body);
  font-size: 13px;
  outline: none;
  transition: border-color .18s, background .18s;
}
/* Ergonomía — el dark-input vive en auth shell (más aire),
   light-input y select viven en formularios densos (height fijo). */
.dark-input  { padding: 11px 14px; }
.light-input { padding: 10px 12px; height: 38px; }
.light-select {
  padding: 10px 32px 10px 12px;
  height: 38px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  cursor: pointer;
}
.dark-input::placeholder,
.light-input::placeholder { color: var(--troly-fg-subtle); }
.dark-input:focus,
.light-input:focus,
.light-select:focus { border-color: var(--troly-action); }
.light-select option { color: var(--troly-fg); background: var(--troly-bg-elevated); }

/* ── Field label ─────────────────────────────────────────────── */
.field-label {
  font-size: 12px;
  font-weight: 500;
  color: var(--ink80);
  margin-bottom: 6px;
  display: block;
}

/* ── Error banner ────────────────────────────────────────────── */
.error-banner {
  background: rgba(248,81,73,.1);
  border: 1px solid rgba(248,81,73,.3);
  color: #f85149;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 13px;
  margin-bottom: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;sEAGsE;AACtE;EACE,kCAAkC;EAClC,sBAAsB;EACtB,sBAAsB;EACtB,uCAAuC;;EAEvC,8BAA8B;EAC9B,uCAAuC;EACvC,8BAA8B;EAC9B,oCAAoC;EACpC,oCAAoC;EACpC,yCAAyC;EACzC,kCAAkC;;EAElC;kDACgD;EAChD,+BAA+B;EAC/B,iCAAiC;EACjC,wCAAwC;;EAExC,8BAA8B;EAC9B,gCAAgC;EAChC,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA,mEAAmE;AACnE,yBAAyB,sBAAsB,EAAE,SAAS,EAAE,UAAU,EAAE;AACxE,OAAO,uBAAuB,EAAE;AAChC;EACE,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,mCAAmC;EACnC,yCAAyC;AAC3C;AACA,IAAI,cAAc,EAAE,qBAAqB,EAAE;AAC3C,MAAM,eAAe,EAAE,cAAc,EAAE;AACvC,SAAS,eAAe,EAAE,wBAAwB,EAAE;AACpD,0BAA0B,wBAAwB,EAAE;;AAEpD,mEAAmE;AACnE,aAAa,iBAAiB,EAAE,cAAc,EAAE,eAAe,EAAE;;AAEjE,mEAAmE;AACnE,iDAAiD;AACjD;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;AACA,mBAAmB,YAAY,EAAE,2BAA2B,EAAE;AAC9D,mBAAmB,wBAAwB,EAAE;AAC7C,qBAAqB,WAAW,EAAE,mBAAmB,EAAE,eAAe,EAAE;;AAExE,+CAA+C;AAC/C;EACE,uBAAuB;EACvB,sBAAsB;EACtB,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,0DAA0D;EAC1D,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;AACA,mBAAmB,iCAAiC,EAAE,4BAA4B,EAAE,sBAAsB,EAAE;;AAE5G,kEAAkE;AAClE;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,mEAAmE;AACnE;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA,oBAAoB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;AAC5D;EACE,UAAU,uCAAuC,EAAE;EACnD,WAAW,wCAAwC,EAAE;AACvD;;AAEA,WAAW,gCAAgC,EAAE;AAC7C,WAAW,gCAAgC,EAAE;;AAE7C,mEAAmE;AACnE,sBAAsB,UAAU,EAAE;AAClC,4BAA4B,uBAAuB,EAAE;AACrD,4BAA4B,uBAAuB,EAAE,kBAAkB,EAAE;;AAEzE,kEAAkE;AAClE;;;EAGE,WAAW;EACX,oCAAoC;EACpC,sBAAsB;EACtB,qCAAqC;EACrC,qCAAqC;EACrC,mCAAmC;EACnC,eAAe;EACf,aAAa;EACb,8CAA8C;AAChD;AACA;oEACoE;AACpE,eAAe,kBAAkB,EAAE;AACnC,eAAe,kBAAkB,EAAE,YAAY,EAAE;AACjD;EACE,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,yDAAoP;EACpP,4BAA4B;EAC5B,sCAAsC;EACtC,eAAe;AACjB;AACA;4BAC4B,6BAA6B,EAAE;AAC3D;;sBAEsB,iCAAiC,EAAE;AACzD,uBAAuB,sBAAsB,EAAE,oCAAoC,EAAE;;AAErF,mEAAmE;AACnE;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,mEAAmE;AACnE;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB","sourcesContent":["/* ── Legacy tokens — alias al sistema Troly · Onyx Club ──────\n   Los 50+ consumidores existentes (`var(--bg)`, `var(--ink)`, etc.)\n   heredan ahora el theming Troly sin tocar reglas individuales.\n   El flip light/dark lo maneja tokens.css vía [data-theme=\"light\"]. */\n:root {\n  --teal:        var(--troly-action);\n  --teal-bright: #2fedcd;\n  --teal-dark:   #0e9e82;\n  --teal-glow:   rgba(69, 230, 194, 0.12);\n\n  --bg:          var(--troly-bg);\n  --surface:     var(--troly-bg-elevated);\n  --ink:         var(--troly-fg);\n  --ink80:       var(--troly-fg-muted);\n  --muted:       var(--troly-fg-muted);\n  --line:        var(--troly-border-strong);\n  --line-soft:   var(--troly-border);\n\n  /* Dark-* tokens — fijos en oscuro siempre (usados por auth\n     shells que no responden al toggle de tema). */\n  --dark-bg:     var(--troly-ink);\n  --dark-surface:var(--troly-steel);\n  --dark-line:   rgba(242, 239, 233, 0.12);\n\n  --font: var(--troly-font-body);\n  --radius: var(--troly-radius-md);\n  --shadow: 0 2px 12px rgba(0,0,0,0.07);\n  --shadow-md: 0 4px 24px rgba(0,0,0,0.10);\n}\n\n/* ── Reset ───────────────────────────────────────────────────── */\n*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }\nhtml { scroll-behavior: smooth; }\nbody {\n  font-family: var(--font);\n  background: var(--bg);\n  color: var(--ink);\n  -webkit-font-smoothing: antialiased;\n  transition: background 0.25s, color 0.25s;\n}\na { color: inherit; text-decoration: none; }\nimg { max-width: 100%; display: block; }\nbutton { cursor: pointer; font-family: var(--font); }\ninput, select, textarea { font-family: var(--font); }\n\n/* ── Layout ──────────────────────────────────────────────────── */\n.container { max-width: 1100px; margin: 0 auto; padding: 0 40px; }\n\n/* ── Buttons ─────────────────────────────────────────────────── */\n/* Primary — migrado a tokens Troly · Onyx Club */\n.btn-teal {\n  background: var(--troly-action);\n  color: var(--troly-action-ink);\n  border: none;\n  border-radius: var(--troly-radius-md);\n  padding: 12px 20px;\n  font-family: var(--troly-font-body);\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1;\n  letter-spacing: -0.005em;\n  transition: opacity .18s, transform .12s;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  cursor: pointer;\n}\n.btn-teal:hover  { opacity: .85; transform: translateY(-1px); }\n.btn-teal:active { transform: translateY(0); }\n.btn-teal:disabled { opacity: .5; cursor: not-allowed; transform: none; }\n\n/* Ghost — migrado a tokens Troly · Onyx Club */\n.btn-ghost {\n  background: transparent;\n  color: var(--troly-fg);\n  border: 1px solid var(--troly-border);\n  border-radius: var(--troly-radius-md);\n  padding: 12px 20px;\n  font-family: var(--troly-font-body);\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: -0.005em;\n  transition: border-color .18s, background .18s, color .18s;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  cursor: pointer;\n}\n.btn-ghost:hover { border-color: var(--troly-action); background: var(--teal-glow); color: var(--troly-fg); }\n\n/* ── Dark page shell (auth screens) ─────────────────────────── */\n.dark-page {\n  min-height: 100vh;\n  background: var(--dark-bg);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  font-family: var(--font);\n}\n\n/* ── Animations ──────────────────────────────────────────────── */\n@keyframes fadeUp {\n  from { opacity: 0; transform: translateY(16px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }\n@keyframes pulse {\n  0%,100% { box-shadow: 0 0 0 0 rgba(69,230,194,.3); }\n  50%      { box-shadow: 0 0 0 8px rgba(69,230,194,0); }\n}\n\n.fade-up { animation: fadeUp .45s ease both; }\n.fade-in { animation: fadeIn .35s ease both; }\n\n/* ── Scrollbar ───────────────────────────────────────────────── */\n::-webkit-scrollbar { width: 5px; }\n::-webkit-scrollbar-track { background: transparent; }\n::-webkit-scrollbar-thumb { background: var(--line); border-radius: 3px; }\n\n/* ── Inputs — unificados sobre tokens Troly · Onyx Club ─────── */\n.dark-input,\n.light-input,\n.light-select {\n  width: 100%;\n  background: var(--troly-bg-elevated);\n  color: var(--troly-fg);\n  border: 1px solid var(--troly-border);\n  border-radius: var(--troly-radius-md);\n  font-family: var(--troly-font-body);\n  font-size: 13px;\n  outline: none;\n  transition: border-color .18s, background .18s;\n}\n/* Ergonomía — el dark-input vive en auth shell (más aire),\n   light-input y select viven en formularios densos (height fijo). */\n.dark-input  { padding: 11px 14px; }\n.light-input { padding: 10px 12px; height: 38px; }\n.light-select {\n  padding: 10px 32px 10px 12px;\n  height: 38px;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' xmlns='http://www.w3.org/2000/svg' fill='none' stroke='%23888888' stroke-width='1.6' stroke-linecap='round'%3E%3Cpath d='M3 4.5l3 3 3-3'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  cursor: pointer;\n}\n.dark-input::placeholder,\n.light-input::placeholder { color: var(--troly-fg-subtle); }\n.dark-input:focus,\n.light-input:focus,\n.light-select:focus { border-color: var(--troly-action); }\n.light-select option { color: var(--troly-fg); background: var(--troly-bg-elevated); }\n\n/* ── Field label ─────────────────────────────────────────────── */\n.field-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--ink80);\n  margin-bottom: 6px;\n  display: block;\n}\n\n/* ── Error banner ────────────────────────────────────────────── */\n.error-banner {\n  background: rgba(248,81,73,.1);\n  border: 1px solid rgba(248,81,73,.3);\n  color: #f85149;\n  border-radius: 8px;\n  padding: 10px 14px;\n  font-size: 13px;\n  margin-bottom: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
